import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
`;
const IframeWrapper = styled.div `
  position: relative;
  height: 700px;
  width: 100%;

  &[data-fixed-height='true'] {
    height: auto;
  }
`;
const Iframe = styled.iframe ``;
export default {
    Container,
    Iframe,
    IframeWrapper,
};
